// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"archway"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 21V9H20V21H4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5 4H19L20 9H4L5 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 4H5M19 4L20 9M19 4H20M19 4V3M5 4L4 9M5 4H4M5 4V3M4 9V21M4 9H3M4 9H9M4 21H3M4 21H9M20 9V21M20 9H21M20 9H15M20 21H21M20 21H15M9 21V9M9 21H15M9 9H15M15 9V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArchwayIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'archway',
    ref,
    icon: element,
  },
));

ArchwayIcon.displayName = 'ArchwayIcon';

export default ArchwayIcon;
